import { startOfMonth, endOfMonth, parse, format, endOfDay } from 'date-fns'

import { SalesPeriodMonth } from './SalesPeriodMonth'

export type SalesPeriod = {
  start: Date
  end: Date
}

export const toSalesPeriod = (date: Date) => ({
  start: startOfMonth(date),
  end: endOfMonth(date),
})

export const SalesPeriod = {
  create(attributes: SalesPeriod) {
    return attributes
  },

  parse(serialized: string) {
    try {
      const [start, end] = JSON.parse(serialized)

      return SalesPeriod.create({
        start: parse(start, 'yyyy-MM-dd', new Date()),
        end: endOfDay(parse(end, 'yyyy-MM-dd', new Date())),
      })
    } catch (error) {
      // For backwards compatibility
      if (error instanceof SyntaxError) {
        return SalesPeriodMonth.parse(serialized)
      }

      throw error
    }
  },

  serialize({ start, end }: SalesPeriod) {
    return JSON.stringify([
      format(start, 'yyyy-MM-dd'),
      format(end, 'yyyy-MM-dd'),
    ])
  },

  toSalesPeriodInput({ start, end }: SalesPeriod) {
    return {
      startAt: format(start, 'yyyy-MM-dd'),
      endAt: format(end, 'yyyy-MM-dd'),
    }
  },
}
